import { createContext, useContext, useEffect, useState } from "react";
import { Snackbar, Alert, Slide, Button, Typography } from "@mui/material";
import {
  firebaseMessaging,
  onFirebaseMessage,
} from "../services/firebaseConfig"; // your FCM setup
import { useUser } from "./AuthProvider";
import axios from "axios";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
const NotificationContext = createContext();
export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const { user, loading } = useUser();
  const [toast, setToast] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const unsubscribe = onFirebaseMessage(firebaseMessaging, (payload) => {
      console.log("📩 Foreground message received", payload);
      setToast(payload.notification);
      setUnreadCount((prev) => prev + 1);
    });

    return () => unsubscribe(); // clean up listener
  }, []);

  useEffect(() => {
    console.log(user);
    if (!loading && user?.id) {
      fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/notify/unread-count/${user.id}`
      )
        .then((res) => res.json())
        .then((data) => setUnreadCount(data))
        .catch((err) => console.error("Unread fetch failed", err));
    }
  }, [user, loading]);

  // 🔔 Realtime FCM push

  const fetchNotifications = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/notify/unreadlist/${user.id}/3`
      ); // API with ?limit=3

      console.log(res.data.notifications);
      setNotifications(res.data.notifications);
    } catch (err) {
      console.error("Notification fetch failed", err);
    }
  };

  const markAllAsRead = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/notify/mark-all-read/${user.id}`
      );
      setUnreadCount(0);
      fetchNotifications(); // refresh list
    } catch (err) {
      console.error("Failed to mark all as read", err);
    }
  };
  const markOneAsRead = async (notifyId) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/notify/mark-read/${notifyId}`
      );
      setNotifications((prev) => prev.filter((n) => n.id !== notifyId));
      setUnreadCount((prev) => (prev > 0 ? prev - 1 : 0));
    } catch (error) {
      console.error("Failed to makr one as read", error);
    }
  };
  return (
    <NotificationContext.Provider
      value={{
        unreadCount,
        notifications,
        fetchNotifications,
        markAllAsRead,
        markOneAsRead
      }}
    >
      {children}
      <Snackbar
        open={!!toast}
        autoHideDuration={4000}
        onClose={() => setToast(null)}
        TransitionComponent={SlideTransition}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          severity={toast?.severity || "info"}
          variant="filled"
          onClose={() => setToast(null)}
          sx={{
            width: "100%",
            boxShadow: 4,
            borderRadius: 2,
            px: 2,
            py: 1.5,
            alignItems: "center",
            overflow: "hidden",
          }}
          action={
            toast?.action ? (
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  toast.action.onClick();
                  setToast(null);
                }}
              >
                {toast.action.label || "View"}
              </Button>
            ) : null
          }
        >
          <Typography variant="h6">New Notification</Typography>
          <strong
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
            }}
          >
            {toast?.title}
          </strong>
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
};
